import { Box, Paper, useMediaQuery } from "@mui/material"
import { useCallback, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { ModalDetalhes as ModalDetalhesComponente } from "src/components/componentes/ModalDetalhes";
import { paths, VerticaisManager } from "src/components/vendas/VerticaisManager";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { TabContent } from "src/framework/components/navigations/tabs/TabContent";
import { TabControl } from "src/framework/components/navigations/tabs/TabControl";
import { authUser$ } from "src/framework/components/navigations/MenuUser";
import api, { apiNoLoading, STATUS_CODE } from "src/framework/providers/api";
import { useObservable } from "src/framework/store/storeUtil";
import { ExtraInfoUsuario } from "src/providers/cadastros/ContaProvider/types";
import { setVendedorInternoModalStatus } from "src/store/vendas/projetos/actions";
import { useProjetosOffGridStore } from "src/store/vendas/projetos/offgrid.store";
import { modalComponentesDetalhesData$ } from "src/store/vendas/projetos/store";
import theme from "src/theme/light";
import { FormProjetoOffGridType } from "../types";
import { projetoSalvoComSucessoDialog } from "../utils/projetoSalvoComSucessoDialog";
import { salvarProjetoHibrido } from "../utils/salvarProjetoHibrido";
import { Solucao } from "./containers/solucao";
import { useProjetosHibridoStore } from "src/store/vendas/projetos/hibrido/hibrido.store";
import { FormProjetoHibridoType } from "src/store/vendas/projetos/hibrido/hibrido.types";

const manager = new VerticaisManager(paths, api, apiNoLoading);

export const ProjetoDimensionadoHibrido = () => {
  const history = useHistory();
  const permissoes = PermissionUtil.getPermissions();
  const authUser = useObservable<ExtraInfoUsuario | undefined>(authUser$)
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const modalComponentesDetalhesData = useObservable(modalComponentesDetalhesData$)

  const projetosHibridoStoreState = useProjetosHibridoStore(store => store.state.data)
  const { reset, changeValue } = useProjetosHibridoStore(store => store.actions)
  
  const [tab, setTab] = useState('solucao')

  const tabs = useMemo(() => {
    return [{ name: "solucao", label: "Solução" }];
  },[])

  const save = useCallback(async (newData: Partial<FormProjetoHibridoType> = {})=>{
    if (!authUser) return;

    const salvarProjetoResponse = await salvarProjetoHibrido(
      manager,
      projetosHibridoStoreState.id,
      {
      ...projetosHibridoStoreState,
      ...newData
      },
      authUser,
      projetosHibridoStoreState.clonar_projeto,
    )

    const allowedStatusCode = [STATUS_CODE.OK, STATUS_CODE.CREATED]
    if(allowedStatusCode.includes(salvarProjetoResponse.statusCode)) {
      projetoSalvoComSucessoDialog(salvarProjetoResponse?.data?.[0]?.codigo_venda, history, {
        tipoProjeto: "dimensionado_hibrido",
        onConfirmation: () => reset(),
        onNegation: () => reset(),
        onClose: () => reset(),
      })
    }
  },[authUser, history, projetosHibridoStoreState, reset])

  const salvarProjeto = useCallback(async ()=>{
    const withPermission = PermissionUtil.can(PermissionUtil.PERMISSION_VENDEDORES_LISTAGEM, permissoes);
    if (withPermission && (!projetosHibridoStoreState.isEdit || projetosHibridoStoreState.clonar_projeto)) {
      setVendedorInternoModalStatus(true, (vendedor) => {
        changeValue({ vendedor_interno: vendedor })
        save({ vendedor_interno: vendedor });
      })
    } else {
      save()
    }
  },[changeValue, permissoes, projetosHibridoStoreState.clonar_projeto, projetosHibridoStoreState.isEdit, save])

  return (
    <>
      {isMobile ? <>
        {tabs.map(item =>(<>
          {item.name === 'solucao' && tab === 'solucao' && (
            <Solucao
              onClickNext={salvarProjeto}
              onClickBack={() => {
                if (projetosHibridoStoreState.isEdit) {
                  history.replace(`/projetos/${projetosHibridoStoreState.id}/hibrido/edicao`, { noReset: true })
                  return;
                }
              
                history.push('/projetos?tipo=dimensionado_hibrido', { noReset: true })
              }}/>
            )}
        </>))}
      </> :      
        <Paper elevation={0} className="tab-header">
          <TabControl
            indicatorColor="primary"
            onChangeTab={() => {}}
            currentTabName={tab}>
            {tabs.map(item => (
              <TabContent
                disabled
                name={item.name}
                visible={true}
                label={
                  <Box display={isMobile ? "none" : "flex"} justifyContent={"center"} alignItems="center">
                    <span style={{ color: theme.palette.text.secondary }}>{item.label}</span>    
                  </Box>
                }>
                  {item.name === 'solucao' && tab === 'solucao' && (
                    <Solucao
                      onClickNext={salvarProjeto}
                      onClickBack={() => {
                      if (projetosHibridoStoreState.clonar_projeto) {
                        history.replace(`/projetos/${projetosHibridoStoreState.id}/dimensionado_hibrido/clonar`, { noReset: true })
                        return;
                      }

                      if (projetosHibridoStoreState.isEdit) {
                        history.replace(`/projetos/${projetosHibridoStoreState.id}/hibrido/edicao`, { noReset: true })
                        return;
                      }
                      
                      history.push('/projetos?tipo=dimensionado_hibrido', { noReset: true })
                    }} />
                  )}

              </TabContent>
            ))}
          </TabControl>        
        </Paper>
      }

      {!!modalComponentesDetalhesData && (
        <ModalDetalhesComponente
          open={!!modalComponentesDetalhesData}
          setOpenModal={(openStatus: boolean) => {
            if (!openStatus) {
              modalComponentesDetalhesData$.next(0);
            }
          }}
          componentId={modalComponentesDetalhesData}
        />
      )}
    </>
  )
}
